import React from "react";

import { CreateAccountTemplate } from "../../templates";

export const CreateAccountPage: React.FC = () => {
  return (
    <CreateAccountTemplate />
  )
};
